const optionsDefaults = {
  attributeNames: {
    styleName: 'className'
  },
  handleMissingStyleName: 'throw'
};

export default optionsDefaults;
